(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgw-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-vgw-masthead] details[open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-vgw-masthead] details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgw-listening-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vgw-listening-gallery')) {
 customElements.define('vgw-listening-gallery', class extends HTMLElement {
  connectedCallback() {
   this.abortController = new AbortController();
   this.addEventListener('click', event => {
    const thumb = event.target.closest('button[data-image]');
    const lifestyle = event.target.closest('[data-lifestyle]');
    const boxSet = event.target.closest('[data-box-set]');
    const chosen = thumb || (boxSet ? Array.from(this.querySelectorAll('button[data-image]')).find(button => button.dataset.image === boxSet.dataset.boxSet) : lifestyle ? this.querySelectorAll('button[data-image]')[1] : null);
    const selected = this.querySelector('.lr-gallery__selected');
    if (!chosen || !selected) return;
    selected.removeAttribute('srcset'); selected.src = chosen.dataset.image; selected.alt = chosen.dataset.alt;
    const caption = this.querySelector('.lr-gallery__caption');
    if (caption) caption.textContent = chosen.dataset.alt;
    this.querySelectorAll('button[data-image]').forEach(button => button.setAttribute('aria-pressed', String(button === chosen)));
   }, {signal:this.abortController.signal});
  }
  disconnectedCallback() { this.abortController?.abort(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vgw-shelf"] && !Shopify.designMode) return;
  try {
    

if (!window.vgwShelfFilterBound) {
  window.vgwShelfFilterBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vgw-filter]');
    if (!button) return;
    const section = button.closest('[data-vgw-shelf]');
    const kind = button.dataset.vgwFilter;
    let visible = 0;
    section.querySelectorAll('[data-vgw-kind]').forEach((card) => {
      card.hidden = kind !== 'all' && card.dataset.vgwKind !== kind;
      if (!card.hidden) visible++;
    });
    section.querySelectorAll('[data-vgw-filter]').forEach((control) => control.setAttribute('aria-pressed', String(control === button)));
    const empty = section.querySelector('[data-vgw-empty]');
    if (empty) empty.hidden = visible > 0;
  });
}


  } catch(e) { console.error(e); }
})();
})();
